import React from "react";
import { X, Loader2, DollarSign } from "lucide-react";

export default function ShippingCostOutModal({
  isOpen,
  onClose,
  onSubmit,
  po,
  shippingCostOut,
  setShippingCostOut,
  submitting = false,
  error = ""
}) {
  if (!isOpen || !po) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "440px" }}>
        <div className="modal-header">
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <DollarSign size={20} color="var(--primary)" />
            <h3 style={{ margin: 0 }}>Shipping Cost Out</h3>
          </div>
          <button className="modal-close" onClick={onClose} disabled={submitting}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={onSubmit}>
          {error && (
            <div className="login-error-alert animate-fade-in" style={{ marginBottom: "1rem" }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: "1.25rem" }}>
            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              background: "rgba(0,0,0,0.15)",
              padding: "0.6rem 0.8rem",
              borderRadius: "6px",
              marginBottom: "0.75rem"
            }}>
              <div>
                <span style={{ fontSize: "0.75rem", textTransform: "uppercase", color: "var(--text-secondary)", fontWeight: 700, display: "block" }}>
                  Estimate
                </span>
                <span style={{ fontWeight: 700, color: "var(--text-primary)", fontSize: "1rem" }}>
                  {po.poNumber || "N/A"}
                </span>
              </div>
              {po.customer && (
                <div style={{ textAlign: "right" }}>
                  <span style={{ fontSize: "0.75rem", textTransform: "uppercase", color: "var(--text-secondary)", fontWeight: 700, display: "block" }}>
                    Customer
                  </span>
                  <span style={{ fontWeight: 600, color: "var(--text-primary)", fontSize: "0.9rem" }}>
                    {typeof po.customer === "object" ? (po.customer.name || po.customer.company || "Unknown") : po.customer}
                  </span>
                </div>
              )}
            </div>

            <p className="text-secondary" style={{ fontSize: "0.85rem", margin: 0, lineHeight: "1.4" }}>
              Input the outbound shipping amount for this estimate. This cost is allocated proportionally across all line items in <strong>Step 5 &amp; Step 6</strong> of the pricing calculation engine.
            </p>
          </div>

          <div className="form-group" style={{ marginBottom: "1.5rem" }}>
            <label className="form-label" htmlFor="shippingCostOutInput" style={{ fontWeight: 600 }}>
              Shipping Cost Out ($)
            </label>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <span style={{ 
                position: "absolute", 
                left: "12px", 
                fontWeight: 700, 
                color: "var(--text-secondary)",
                fontSize: "1.05rem" 
              }}>
                $
              </span>
              <input
                id="shippingCostOutInput"
                type="number"
                min="0"
                step="0.01"
                required
                className="form-input"
                style={{ paddingLeft: "26px", fontSize: "1.05rem", fontWeight: 700 }}
                placeholder="0.00"
                value={shippingCostOut}
                disabled={submitting}
                onChange={(e) => setShippingCostOut(e.target.value)}
                onFocus={(e) => e.target.select()}
                onClick={(e) => e.target.select()}
                autoFocus
              />
            </div>
            <span className="text-secondary" style={{ fontSize: "0.78rem", display: "block", marginTop: "0.4rem" }}>
              Step 5 formula: <code>Shipping Out / Total Cost Amount = New Decimal</code> (6 decimals)
            </span>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem" }}>
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={submitting}
              style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem" }}
            >
              {submitting && <Loader2 size={16} className="animate-spin" />}
              {submitting ? "Saving..." : "Save & Recalculate"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
